import React, { useState, createContext, useContext } from "react";
import styles from "./styles.module.css";

const ToggleTabContext = createContext();

export function ToggleTabs({ defaultValue, children, onChange }) {
  const [activeTab, setActiveTab] = useState(defaultValue);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    if (onChange) {
      onChange(newTab);
    }
  };

  return (
    <ToggleTabContext.Provider
      value={{ activeTab, setActiveTab: handleTabChange }}
    >
      <main className={styles.toggle_tabs_container}>{children}</main>
    </ToggleTabContext.Provider>
  );
}

export function ToggleTabList({ children }) {
  return <section className={styles.toggle_tab_list}>{children}</section>;
}

export function ToggleTabTrigger({ value, children }) {
  const { activeTab, setActiveTab } = useContext(ToggleTabContext);
  const isActive = activeTab === value;

  return (
    <div
      className={`${styles.toggle_tab_trigger} ${
        isActive ? styles.toggle_tab_trigger_active : ""
      }`}
      onClick={() => setActiveTab(value)}
    >
      {children}
    </div>
  );
}

export function ToggleTabPanels({ children }) {
  return (
    <section className={styles.toggle_tab_panels_container}>{children}</section>
  );
}

export function TogglePanel({ value, children }) {
  const { activeTab } = useContext(ToggleTabContext);
  if (activeTab !== value) return null;
  return <section className={styles.toggle_tab_panel}>{children}</section>;
}
